<template>
  <div
    class="lg:flex md:block lg:gap-6 justify-center md:gap-6 bg-white lg:px-20 md:px-10"
  >
    <div class="lg:w-1/2 md:w-full w-full cust-negmargin">
      <div class="lg:px-20 md:px-20 px-5">
        <div class="shadow-lg rounded-lg">
          <img src="@/assets/images/Group 147.jpg" alt="" class="rounded-lg" />

          <div class="">
            <div class="lg:px-20 md:px-20 px-5 bg-white">
              <p class="text-00adc0 fsize18 pt-5">Premium Pass</p>
              <h2 class="text-primary font-bold fsize25 pt-5">
                ₹2,000/<span class="">Month</span>
              </h2>
              <p class="pt-2">
                The only compass you’ll ever need to guide you through your
                caregiving journey.
              </p>
              <div class="pt-5 pb-16">
                <div class="flex gap-2 items-center py-2">
                  <feather-icon svgClasses="w-5 h-5" class="flex" icon="CheckIcon" />
                  <p>Access all our premium resources</p>
                </div>
                <div class="flex gap-2 items-center py-2">
                  <feather-icon svgClasses="w-5 h-5" class="flex" icon="CheckIcon" />
                  <p>Access all our premium resources</p>
                </div>
                <div class="flex gap-2 items-center py-2">
                  <feather-icon svgClasses="w-5 h-5" class="flex" icon="CheckIcon" />
                  <p>Access all our premium resources</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lg:w-1/2 md:w-full w-full lg:px-0 md:px-0 px-5 lg:pt-0 md:pt-0 pt-10">
      <div class="lg:w-3/4 md:w-3/4 md:mx-auto lg:mt-0 md:mt-6 mt-4">
        <h2 class="text-primary fsize25 font-bold">
          Bring out the best within you as a caregiver
        </h2>
        <p class="fsize18">
          Access content, services & products curated with the efforts of
          thousands of caregivers across the country. Your road may be bumpy but
          we can make it better, together.
        </p>
        <div class="mt-8">
          <b-button
            type="primary"
            class="bg-primary fsize20 text-white rounded-full w-full"
            >Get it Now</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      currMembership: {},
      currTransactionId: "",
    };
  },
  methods: {
    handleRegister(name) {
      this.$router.push({ name: name });
    },
    handleBuy(membership) {
      let self = this;
      this.currMembership = membership;
      if (this.currMembership.price <= 0) {
        return;
      }
      const totalPrice = parseInt(this.currMembership.price);
      var amount = Number(totalPrice) * 100;
      var paymentRecord = async (response) => {
        var responcenew = await this.handlePaymentRecord(response);
        this.currTransactionId = responcenew.data._id;
        if (responcenew) {
          const payload = {
            userId: this.user._id,
            membershipId: this.currMembership._id,
            plansIncluded: this.currMembership.plansIncluded,
            membershipName: this.currMembership.name,
            price: parseInt(this.currMembership.price),
            transactionId: responcenew.data._id,
            validity: parseInt(this.currMembership.validity),
            orderId: responcenew.data.orderId,
            paymentStatus: "success",
          };
          let loader = this.$loading();
          try {
            const data = await this.$store.dispatch(
              "payment/CreatePayment",
              payload
            );
            if (data.code == 200) {
              let TransPayload = {
                _id: responcenew.data._id,
                transactionstatus: "Success",
              };
              await this.$store.dispatch(
                "transaction/UpdateTransaction",
                TransPayload
              );
              let getUserPayload = {
                userId: this.user._id,
              };
              const getUser = await this.$store.dispatch(
                "auth/getUserByUserId",
                getUserPayload
              );
              // console.log("GETUSERBYUSERID:", this.getUserByUserId);
              loader.close();
              // console.log("payment success");
            }
            loader.close();
          } catch (error) {
            loader.close();
            console.log(error);
          }
        }
      };
      this.$store
        .dispatch("payment/CreateOrderPayment", {
          amount: Number(amount),
        })
        .then(async (_) => {
          console.log(_);
          if (Object.keys(_.data).length == 0) {
            // console.log("Payment failed");
            return;
          }
          var options = {
            key: process.env.RAZORPAY_KEY_ID,
            amount: _.data.amount.toString(),
            currency: "INR",
            name: `${this.user.firstname || ""} ${this.user.lastname || ""}`,
            description: `Membership Id: ${this.currMembership._id} / Membership Name: ${this.currMembership.name}`,
            order_id: _.data.id,
            handler: function (response) {
              paymentRecord(response);
            },
            prefill: {
              name: `${this.user.firstname || ""} ${this.user.lastname || ""}`,
              email: `${this.user.email || ""}`,
              phone: `${this.user.mobile || ""}`,
            },
          };
          var rzp1 = new Razorpay(options);
          rzp1.on("payment.failed", async function (response) {
            // console.log("FAILEDTRANSACTION");
            self.handleFaliedTransaction();
          });
          rzp1.open();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async handlePaymentRecord(responce) {
      try {
        let payload = {
          transactionId: responce.razorpay_signature,
          transactionstatus: "In-Progress",
          transactionMode: "online",
          orderId: responce.razorpay_order_id,
          membershipId: this.currMembership._id,
          razorpayKey: {
            razorpay_payment_id: responce.razorpay_payment_id,
            razorpay_order_id: responce.razorpay_order_id,
            razorpay_signature: responce.razorpay_signature,
          },
        };
        const transactionrecord = await this.$store.dispatch(
          "transaction/CreateTransaction",
          payload
        );
        this.currTransactionId = transactionrecord.data._id;
        return transactionrecord;
      } catch (err) {
        console.log(err);
      }
    },
    async handleFaliedTransaction() {
      let TransPayload = {
        _id: this.currTransactionId,
        transactionstatus: "Failed",
      };
      let data = await this.$store.dispatch(
        "transaction/UpdateTransaction",
        TransPayload
      );
      // console.log("FAILEDTRANSACTIONRESPONSE", data);
    },
    isObjEmpty(value) {
      if (Object.keys(value).length === 0 && value.constructor === Object) {
        return true;
      }
      return false;
    },
    async init() {
      try {
        await this.$store.dispatch("subscribe/GetAllMembership");
        if (this.user && this.user._id) {
          let getUserPayload = {
            userId: this.user._id,
          };
          const getUser = await this.$store.dispatch(
            "auth/getUserByUserId",
            getUserPayload
          );
        }
        // console.log("INIT", this.getUserByUserId, this.get_all_membership);
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
    }),
    ...mapState("auth", { user: "user" }),
    ...mapState("auth", { getUserByUserId: "getUserByUserId" }),
  },
  watch: {},
  async mounted() {
    await this.init();
  },
};
</script>

<style>
.text-00adc0 {
  color: #00adc0;
}
.Custborder-radius {
  border-radius: 20px 20px 20px 20px !important;
}
</style>
